export type EnvironmentConfig = {
  url: string;
  host: string;
  keycloak: {
    url: string;
    realm: string;
    clientId: string;
  };
  prometheus: {
    namespace: string;
  };
};

export const ENV_CONFIG: Record<string, EnvironmentConfig> = {
  development: {
    url: 'https://dev-cyclone.onepredict.net',
    host: 'dev-cyclone.onepredict.net',
    keycloak: {
      url: 'https://dev-keycloak.onepredict.net/',
      realm: 'dev-cyclone',
      clientId: 'dev-cyclone',
    },
    prometheus: {
      namespace: 'dev-cyclone',
    },
  },
  staging: {
    url: 'https://stg-cyclone.onepredict.net',
    host: 'stg-cyclone.onepredict.net',
    keycloak: {
      url: 'https://stg-keycloak.onepredict.net/',
      realm: 'stg-cyclone',
      clientId: 'stg-cyclone',
    },
    prometheus: {
      namespace: 'stg-cyclone',
    },
  },
  demo: {
    url: 'https://demo-cyclone.onepredict.net',
    host: 'demo-cyclone.onepredict.net',
    keycloak: {
      url: 'https://demo-keycloak.onepredict.net/',
      realm: 'demo-cyclone',
      clientId: 'demo-cyclone',
    },
    prometheus: {
      namespace: 'demo-cyclone',
    },
  },
  production: {
    url: 'https://cyclone.guardione.ai',
    host: 'cyclone.guardione.ai',
    keycloak: {
      url: 'https://keycloak.onepredict.net/',
      realm: 'prod-cyclone',
      clientId: 'prod-cyclone',
    },
    prometheus: {
      namespace: 'prod-cyclone',
    },
  },
} as const;

export const getEnvironmentConfig = (mode: string): EnvironmentConfig => {
  const config = ENV_CONFIG[mode];

  if (!config) {
    console.warn(`⚠️  Unknown mode: "${mode}", falling back to development`);
    return ENV_CONFIG.development;
  }

  return config;
};
